module.exports = __webpack_public_path__ + "static/media/blanco.2c987d7e.png";